
<template>
  <div>
    <el-dialog title="选择辅助管理员" :visible.sync="showSelectadmin" :before-close="handleClose"
      :close-on-click-modal="false" :append-to-body="true" lock-scroll
      :close-on-press-escape="false" class="QMS-dialog QMS-dialog_center" width="30%" center>
      <div class="QMS-common-layout-main">
        <el-table ref="multipleTable" :append-to-body="true" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center">
          </el-table-column>
          <el-table-column type="index" width="55" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="userName" label="管理员编号" align="center">
          </el-table-column>
          <el-table-column prop="nickName" label="姓名" align="center">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button type="primary" size="mini" @click="selectOk">确定</el-button>
        <el-button plain size="mini" @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    eqid: {
      default: false
    },
    showSelectadmin: {
      default: false

    },
    selectData: {

    }
  },
  data() {
    return {
      tableData: [],
      selectionData: []
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    handleSelectionChange(e) {
      this.selectionData = e
    },
    init() {
      let idData = {
        assistEquipmentId: this.eqid
      }
      this.$net(`/sdau/usermanage/selectStudentUserList`, 'post', idData).then(res => {
        this.tableData = res.data
        if (this.selectData.length) {
          this.tableData.forEach(item => {
            this.selectData.forEach(items => {
              if (item.userId == items.userId) {
                this.$nextTick(() => {
                  this.$refs.multipleTable.toggleRowSelection(item, true)
                })
              }
            })
          })
        }
      })

    },
    selectOk() {
      this.$emit('getAdmin', this.selectionData)
      this.handleClose()
    }
  },
  created() {
    this.init()
  }
}
</script>
